import React from "react";
import JokerProDownload from "./JokerProDownload";
import style from "./OverDivComponent.module.css";

interface OverDivComponentProps {
  title: string;
  description: string;
  downloadLink?: string;
  learnMoreLink?: string;
  secondButtonName?: string;
}

const OverDivComponent: React.FC<OverDivComponentProps> = ({
  title,
  description,
  downloadLink = "main",
  learnMoreLink = "main",
  secondButtonName,
}) => {
  return (
    <div className={style.container}>
      <div className={style.sub_container}></div>
      <div className={style.info_container}>
        <JokerProDownload
          title={title}
          description={description}
          downloadLink={downloadLink}
          learnMoreLink={learnMoreLink}
          secondButtonName={secondButtonName}
        />
      </div>
    </div>
  );
};

export default OverDivComponent;
